import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isNil } from 'lodash';

import { Settings } from '../../core';

@Injectable()
export class EmulationInterceptor implements HttpInterceptor {
    constructor(
        private settings: Settings
    ) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
        if (!req.url.startsWith(this.settings.apiUrl)) {
            return next.handle(req);
        }

        if (!isNil(this.settings.emulatedUserId) && !req.headers.has('ignoreEmulation')) {
            const emulReq = req.clone({ setParams: { [`${this.settings.emulateAsParamName}`]: `${this.settings.emulatedUserId}` } });
            return next.handle(emulReq);
        }
        return next.handle(req);
    }
}